<template>
  <div class="Confirmation center-xs">
    <div v-if="feature === 'GiftCard'">
      <div class="confirmation-thankyou">
        {{ cardDetails.senderName ? $vuetify.lang.t("$vuetify.confirmation.thankyouWithName", cardDetails.senderName) : $vuetify.lang.t("$vuetify.confirmation.thankyou") }}
      </div>

      <spacer size="xl"></spacer>

      <gift-card-design :design-code="cardDetails.designCode" />

      <spacer size="m"></spacer>

      <div class="fs-l fw-bold" v-if="cardDetails.customMessage">
        "{{ cardDetails.customMessage }}"
      </div>
      <spacer v-else size="m"></spacer>

      <div
        style="text-align: right; margin-top: 10px; margin-right: 30px;"
        v-if="cardDetails.senderName"
      >
        - {{ cardDetails.senderName }}
      </div>

      <div class="confirmation-gift-card-value">
        <div class="fs-l fw-bold">
          {{ $vuetify.lang.t("$vuetify.confirmation.giftCardValue") }}
        </div>
        <div class="confirmation-gift-card-value-amount">
          {{ getPurchaseInfo.purchaseAmount | currency(true) }}
        </div>
      </div>

      <div class="confirmation-gift-card-value" v-if="bonusAmount > 0">
        <div class="confirmation-gift-card-value-label">
          {{ $vuetify.lang.t("$vuetify.confirmation.bonus") }}
        </div>
        <div class="confirmation-gift-card-value-amount">
          + {{ bonusAmount | currency(true) }}
        </div>
      </div>

      <spacer size="m" border-bottom></spacer>
      <spacer size="m"></spacer>

      <div>
        {{
          $vuetify.lang.t(
            "$vuetify.confirmation.weveSentTheGiftCardTo",
            cardDetails.receiverEmail || cardDetails.receiverMobile
          )
        }}
        <strong>
          {{ cardDetails.receiverEmail || cardDetails.receiverMobile }} </strong
        >. {{ $vuetify.lang.t("$vuetify.confirmation.itShouldArriveShortly") }}
      </div>
      <spacer size="xl"></spacer>

      <div class="confirmation-buttons">
        <v-btn
          color="primary"
          @click="toOwaPage"
          rounded
          style="padding:0 100px; text-transform: none;"
        >
          {{ $vuetify.lang.t("$vuetify.confirmation.startAnOrder") }}
        </v-btn>

        <v-btn
          rounded
          @click="returnToStart"
          style="padding:0 100px; text-transform: none;"
        >
          {{ $vuetify.lang.t("$vuetify.confirmation.purchaseAnotherCard") }}
        </v-btn>
      </div>
      <br />
    </div>
    <div v-else-if="feature === 'Deposit'">
      <div class="fs-xl fw-bold">
        {{ $vuetify.lang.t("$vuetify.confirmation.depositSuccess") }}
      </div>

      <spacer size="s"></spacer>

      <div class="fs-l fw-bold" style="color: var(--primary-color);">
        {{ $vuetify.lang.t("$vuetify.confirmation.depositSuccessful") }}
      </div>

      <div class="checkout-detail-row fs-s">
        <div>{{ $vuetify.lang.t("$vuetify.confirmation.addedTo") }}</div>
        <div>{{ depositDetails.telephone | phoneNumber }}</div>
      </div>

      <spacer size="m" border-bottom></spacer>
      <spacer size="m"></spacer>

      <div class="checkout-detail-row fs-s">
        <div>{{ $vuetify.lang.t("$vuetify.confirmation.depositValue") }}</div>
        <div>{{ depositDetails.amount | currency(true) }}</div>
      </div>
      <template
        v-if="getDepositBonusByAmount && getDepositBonusByAmount.bonusCash > 0"
      >
        <spacer size="m"></spacer>
        <div class="checkout-detail-row fs-s">
          <div>{{ $vuetify.lang.t("$vuetify.confirmation.bonus") }}</div>
          <div>{{ getDepositBonusByAmount.bonusCash | currency(true) }}</div>
        </div>
      </template>

      <template
        v-if="getDepositPointsByAmount && getDepositPointsByAmount.bonusPoints > 0"
      >
        <spacer size="m"></spacer>
        <div class="checkout-detail-row fs-s">
          <div>{{ $vuetify.lang.t("$vuetify.checkout.points") }}</div>
          <div>{{ getDepositPointsByAmount.bonusPoints }} {{ $vuetify.lang.t("$vuetify.checkout.points") }}</div>
        </div>
      </template>


      <spacer size="m"></spacer>
      <div class="checkout-detail-row fs-l fw-bold">
        <div>{{ $vuetify.lang.t("$vuetify.confirmation.deposited") }}</div>
        <div>
          {{ depositTotalAmount | currency(true) }}
        </div>
      </div>

      <spacer size="m" border-bottom></spacer>
      <spacer size="m"></spacer>

      <div class="row center-xs fs-s">
        {{ $vuetify.lang.t("$vuetify.confirmation.creditAddedToMembership") }}
      </div>

      <spacer size="xl"></spacer>

      <div class="confirmation-buttons">
        <v-btn
          color="primary"
          @click="toOwaPage"
          rounded
          style="padding:0 100px; text-transform: none;"
        >
          {{ $vuetify.lang.t("$vuetify.confirmation.startAnOrder") }}
        </v-btn>

        <v-btn
          rounded
          @click="returnToStart"
          style="padding:0 100px; text-transform: none;"
        >
          {{ $vuetify.lang.t("$vuetify.confirmation.makeAnotherDeposit") }}
        </v-btn>
      </div>
      <!-- <h3 v-if="balance !== null">
        {{ $vuetify.lang.t("$vuetify.confirmation.newBalance") }}
        {{ balance | currency }}
      </h3> -->
    </div>
    <div v-else>
      <h2>
        {{ $vuetify.lang.t("$vuetify.confirmation.couponPurchase") }}
      </h2>

      <div class="row around-xs" id="coupons">
        <div
          v-for="coupon in coupons"
          :key="coupon.code"
          class="col-xs-12 col-sm-6"
        >
          <coupon-card :coupon="coupon" immutable />
        </div>
      </div>
    </div>

    <div
      class="row buttonRow around-xs"
      v-if="feature !== 'GiftCard' && feature !== 'Deposit'"
    >
      <a v-if="OWALink" :href="OWALink" class="col-xs-12 col-md-6">
        <v-btn color="primary" @click="clearState">
          {{ useFunds }}
        </v-btn>
      </a>
      <a v-else-if="HomeLink" :href="HomeLink" class="col-xs-12 col-md-6">
        <v-btn color="primary" @click="clearState">
          {{ $vuetify.lang.t("$vuetify.common.home") }}
        </v-btn>
      </a>

      <div class="col-xs-12 col-md-6">
        <v-btn color="secondary" @click="returnToStart">
          {{ getAnother }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash";
import { mapMutations, mapGetters } from "vuex";

import CouponCard from "../common/CouponCard";
import GiftCardDesign from "../feature/GiftCardDesign";
import Spacer from "../common/Spacer";
export default {
  components: { CouponCard, GiftCardDesign, Spacer },

  data: () => ({
    balance: null,
  }),

  computed: {
    getAnother() {
      if (this.feature === "GiftCard") {
        return this.$vuetify.lang.t(
          "$vuetify.confirmation.makeAnotherPurchase"
        );
      } else {
        return this.$vuetify.lang.t("$vuetify.confirmation.makeAnotherDeposit");
      }
    },
    useFunds() {
      if (this.feature === "GiftCard") {
        return this.$vuetify.lang.t("$vuetify.confirmation.useFundsPurchase");
      } else {
        return this.$vuetify.lang.t("$vuetify.confirmation.useFundsDeposit");
      }
    },
    HomeLink() {
      if (this.$parent.$parent.returnUrl) return this.$parent.$parent.returnUrl;
      return null;
    },
    OWALink() {
      if (this.feature !== "Deposit" && this.feature !== "GiftCard")
        return null;

      if (this.HomeLink) return this.HomeLink;

      // Only allow going to OWA if the store supports it
      if (get(this.build, "features.orderingSupported", false)) {
        let storeId = get(this.build, "storeId", false);
        let groupId = get(this.build, "groupId", false);
        let host = window.location.origin;
        let groupRedirect = get(
          this.build,
          "settings.membershipSettings.redirectToGroupPageAfterSelfcareDeposit",
          false
        );
        if (groupRedirect) {
          return `${host}/owa/snappy/detail/${groupId}`;
        } else if (!!storeId && !!groupId && !!host) {
          return `${host}/owa/snappy/detail/${groupId}/${storeId}`;
        }
      }

      return null;
    },

    coupons() {
      return get(this.couponDetails, "coupons", []);
    },

    depositTotalAmount() {
      const amount =
        Number(this.depositDetails.amount) +
        Number(this.getDepositBonusByAmount?.bonusCash || 0);
      return amount;
    },

    bonusAmount() {
      if (
        this.getPurchaseInfo &&
        this.getPurchaseInfo.amount > 0 &&
        this.getPurchaseInfo.amount -
          (this.getPurchaseInfo?.purchaseAmount || 0) >
          0
      ) {
        return (
          this.getPurchaseInfo.amount -
          (this.getPurchaseInfo?.purchaseAmount || 0)
        );
      }
      return 0;
    },

    ...mapGetters({
      build: "getBuild",
      storeId: "getStoreID",
      feature: "getFeature",
      getAmount: "getAmount",
      cardDetails: "getCardDetails",
      couponDetails: "getCouponDetails",
      depositDetails: "getDepositInfo",
      billingInfo: "getBillingInfo",
      getPurchaseInfo: "getPurchaseInfo",
      getStore: "getStore",
      getBonusByAmount: "getBonusByAmount",
      getDepositBonusByAmount: "getDepositBonusByAmount",
      getDepositPointsByAmount: "getDepositPointsByAmount",
    }),
  },

  methods: {
    clearState() {
      // Clear the recipients info once the purchase has been completed
      this.setCardDetails({
        ...this.cardDetails,
        receiverMobile: null,
        customMessage: null,
        amount: null,
        otherAmount: null,
      });

      this.setBillingInfo({
        transactionId: null,
        paymentMethodId: null,
      });

      this.setDepositDetails({
        ...this.depositDetails,
        amount: null,
      });

      this.setCouponDetails({
        ...this.couponDetails,
        coupons: [],
        cart: null,
      });

      this.setPurchaseInfo({});
    },

    returnToStart() {
      this.clearState();
      this.setPurchaseInfo({});

      this.$router.push({
        name: "Home",
        params: { storeId: this.storeId },
      });

      this.$parent.$parent.initStore();
    },

    toOwaPage() {
      window.location.href = this.OWALink;
    },

    ...mapMutations([
      "setCardDetails",
      "setDepositDetails",
      "setCouponDetails",
      "setPurchaseInfo",
      "setBillingInfo",
    ]),
  },

  mounted() {
    if (this.feature === "Deposit") {
      this.$api
        .get(`/rwa/selfcare/deposit/balance/${this.billingInfo.transactionId}`)
        .then((res) => {
          this.balance = res.data.balance;
        });
    }
  },
};
</script>

<style scoped>
.Confirmation {
  position: relative;
  max-width: 600px;
  margin: 0px;
}

h2 {
  margin: 0px 0px 20px;
}
h3 {
  margin-top: 10px;
}

a {
  text-decoration: none;
}

.buttonRow {
  max-width: 600px;
  margin: 40px auto;
}
.buttonRow button {
  width: 100%;
}

.CardPreview #CardPreview {
  width: 400px;
  max-width: 80vw;
}

.confirmation-thankyou {
  font-size: 36px;
  line-height: 56px;
  font-weight: 700;
  text-align: center;
}

.confirmation-gift-card-value {
  display: flex;
  padding: 0 30px;
  justify-content: space-between;
  align-items: center;
}
.confirmation-gift-card-value-label {
  font-size: 24px;
  line-height: 36px;
  font-weight: 700;
}
.confirmation-gift-card-value-amount {
  font-size: 48px;
  line-height: 72px;
  font-weight: 700;
}
.confirmation-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.checkout-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .confirmation-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .confirmation-thankyou {
    padding-top: 48px;
  }
}
</style>
